module.exports = __webpack_public_path__ + "img/LUGHY_LOGO.e8d0f68a.png";